import { gql } from '@apollo/client';

const ACCOUNT_HISTORY_APPLICATION = gql`
  query AccountHistory($applicationId: String!) {
    auto: automatedUpdatesV3(applicationId: $applicationId) {
      id
      customerId
      agentId
      agentName
      message
      product
      createdTz
      updatedTz
      __typename
    }
  }
`;
const ACCOUNT_HISTORY_CUSTOMER = gql`
  query AccountHistory($customerId: String!) {
    auto: automatedUpdatesV3(customerId: $customerId) {
      id
      customerId
      agentId
      agentName
      message
      product
      createdTz
      updatedTz
      __typename
    }
    comms: commCustomerRecords(customerId: $customerId, page: 0, size: 500) {
      content {
        actionName
        communicationType
        documentId
        provider
        sentDate
        title
        __typename
      }
      __typename
    }
    perAccount: customer(customerId: $customerId) {
      id
      creditAccounts {
        id
        digitalWallet {
          id: accountId
          events {
            vendor
            status
            date
            time
            tokenNumber
            tokenRequesterId
            reason
            indicator
          }
        }
        memos {
          digitalWalletMemos {
            alertType
            date
            notificationChannel
            time
            type
          }
          fraudMemos {
            alertType
            date
            notificationChannel
            time
            type
          }
        }
      }
    }
  }
`;

export { ACCOUNT_HISTORY_APPLICATION, ACCOUNT_HISTORY_CUSTOMER };
